import Visiferm		from "./circuits/visiferm-ph.js";
import sleep      	from "sleep";

class PHSensor extends Visiferm {
  constructor(...args) {
    super(...args);

    this.id = "-";
    this.value = "-";
    this.status = "uninitialized";
    this.calibrationStatus = "-";
    this.internalTemperature = "N/A";
    this.temperatureCompenstationStatus = "auto";
  }
  async initialize() {
    try {
      await sleep(2500);
      this.id = await this.getSensorIdentification();
      //await this.setPMC1PhysicalUnit(0x20);
      this.status = "ok";
    } catch(e) {
      this.status = "failed: " + e;
      throw e;
    }
  }
  async update() {    
    await sleep(2500);
    this.value = Math.round(await this.getPH()*100)/100;
    this.internalTemperature = Math.round(await this.getTemperature()*100)/100;
    this.calibrationStatus = await this.getCalibrationStatus();
  }
  async clearCalibration() {
    throw "not implemented";
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      calibrationStatus: this.calibrationStatus,
      value: this.value,
      internalTemperature: this.internalTemperature,
      temperatureCompenstationStatus: this.temperatureCompenstationStatus
    });
  }
}

export default PHSensor;